import React from 'react';
import { PapiComment } from '@wix/da-papi-types';
import CommentTiptapViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/Comment';
import TextRenderer from '../../../TextRenderer';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import s from './ContentTextRenderer.scss';

interface Props {
  comment: PapiComment;
}

const ContentTextRenderer: React.FC<Props> = ({ comment }) => {
  const { commentId, textContent } = comment;
  return (
    <div>
      <TextRenderer
        className={s['renderer']}
        textContent={textContent}
        legacyTheme={'comments'}
        viewerKey={commentId}
        tipTapViewer={CommentTiptapViewer}
        cookieType={MeasuredCookieType.COMMENT_RENDERER}
        defaultSize={{
          desktop: { width: 580, height: 80 },
          mobile: { width: 380, height: 80 },
        }}
      />
    </div>
  );
};
ContentTextRenderer.displayName = 'ContentTextRenderer';

export default ContentTextRenderer;
